import React from 'react';
import { render } from 'react-dom';

class WbmImage extends React.Component {
    constructor(props) {
        super(props);

        this.handleError = this.handleError.bind(this);

        var imageUrl = this.props.src;
        if (!this.props.src || this.props.src === "" || this.props.src == "http:///") {
            imageUrl = this.props.defaultImageUrl ? this.props.defaultImageUrl : "http://images.wbmason.com/240/nia-240.jpg";
        }

        this.state = {
            imageUrl: imageUrl
        }
    }

    handleError() {
        this.setState({
            imageUrl: this.props.defaultImageUrl ? this.props.defaultImageUrl : "http://images.wbmason.com/240/nia-240.jpg"
        })
    }

    render() {
        return (
            <img 
                className={this.props.class}
                src={this.state.imageUrl}
                alt={this.props.altText}
                title={this.props.title}
                width={this.props.width}
                height={this.props.height}
                onError={this.handleError}
            />
        );
    }
}
export default WbmImage;  